<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <!-- NOTA
        v-if="dataOriginOptions.length"
        Fix para problema de asincronismo en modo edición.
        Me aseguro de cargar las opciones antes del v-model
       -->
      <LmTreeSelect
        v-if="dataOriginOptions.length"
        class="col-6"
        :placeholder="$t('data_origin')"
        :label="$t('data_origin')"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
        :options="dataOriginOptions"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  components: {
    LmTextInput,
    LmCheckbox,
    LmTreeSelect
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        }
      ],
      dataOriginOptions: [],
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      dataOrigin: {
        required
      }
    }
  },
  async created () {
    try {
      const res = await commonsApi.axiosGetWrapper('/datatables/all')
      this.dataOriginOptions = res.data.items
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
